import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import { HttpService } from "../../service/HttpService";

const handleDownloadInventoryExcel = async (setShowLoginPopup, ids = []) => {
  const httpService = new HttpService(setShowLoginPopup);

  const fetchInventoryData = () => {
    return new Promise((resolve, reject) => {
      const idParam = ids.join(","); // Convert array to comma-separated string

      httpService
        .get(`inventory/byids?ids=${idParam}`)
        .then((response) => {
          if (response?.data) {
            const inventoryData = response?.data;
            resolve(inventoryData);
          } else {
            reject(new Error("No data found"));
          }
        })
        .catch((error) => {
          console.error("Error fetching inventory data:", error);
          reject(error);
        });
    });
  };

  try {
    const inventoryData = await fetchInventoryData();

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Inventory");

    worksheet.addRow([
      "Item Name",
      "Stored Location",
      "Reorder Threshold",
      "Unit",
      "Reorder Amount",
      "On-Hand Quantity",
      "Department",
      "Purchased Qty",
      "Used Qty",
    ]);
    worksheet.getRow(1).alignment = { horizontal: "center" };

    if (Array.isArray(inventoryData) && inventoryData.length > 0) {
      inventoryData.forEach((item) => {
        worksheet.addRow([
          item?.item_name || "",
          item?.stored_location || "",
          parseFloat(item?.reorder_threshold) || "",
          item?.unit || "",
          parseFloat(item?.reorder_amount) || "",
          parseFloat(item?.on_hand_qty) || "",
          item?.department_name || "",
          item?.purchased_qty || "",
          item?.used_qty || "",
        ]);
      });
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const formattedDate = moment().format("MM-DD-YYYY_hh-mm-ss_A");
    saveAs(new Blob([buffer]), `InventoryData_${formattedDate}.xlsx`);
  } catch (error) {
    console.error("Error downloading inventory Excel:", error);
  }
};

export { handleDownloadInventoryExcel };
